/**
 * @file WmsSettingsHeader.tsx
 * @description Заголовок «Настроек склада» в верхней панели (phase19.31,
 * зона «Склад»; SC33, SC34).
 *
 * Один заголовок на все вкладки, а главное действие — у вкладки: «Сохранить»
 * есть у «Правил» и «Этикеток», у «Устройств» и «Рабочего места» его нет
 * (там всё применяется сразу). Поэтому заголовок рисует та часть страницы,
 * которая знает о сохранении, — как «Задания на сборку» рисуют его в панели
 * режима. На телефоне и планшете пояснение не занимает строку над вкладками,
 * а «Сохранить» — в общей нижней полосе каркаса.
 */

import type { ReactNode } from "react";

import { CabinetPageHeader } from "../../ui/CabinetPageHeader";
import { BELOW_LG_QUERY, useMediaQuery } from "../../../hooks/useMediaQuery";

export function WmsSettingsHeader({ action }: { action?: ReactNode }) {
  const compact = useMediaQuery(BELOW_LG_QUERY);
  return (
    <CabinetPageHeader
      title="Настройки склада"
      subtitle={compact ? undefined : "Правила склада, устройства, рабочее место и этикетки"}
      action={action}
    />
  );
}
